import { Spinner } from "@material-tailwind/react";
import ClientReservationDetailedCard from "components/ClientReservationCard/ClientReservationDetailedCard";
import ReservationsDetailedCard from "components/FlightCard/ReservationsDetailedCard";
import Heading2 from "components/Heading/Heading2";
import ModernClientEventsGrid from "components/Client/ModernClientEventsGrid";
import { AuthContext } from "context/appContext";
import { Reservation } from "data/types";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { FC, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  fetchReservationByOwner,
  fetchReservationByOwnerAsClient,
} from "redux/features/reservations/reservationSlice";
import Pagination from "shared/Pagination/Pagination";

export interface SectionGridFilterCardProps {
  className?: string;
  selectedFilter?: string;
  filterStatus?: string | null;
}

const MadeReservationGridDetailedCard: FC<SectionGridFilterCardProps> = ({
  className = "",
  selectedFilter = "all",
  filterStatus = null,
}) => {
  const authContext = useContext(AuthContext);
  const [loading, setIsLoading] = useState(false);
  const profilId = authContext?.user?.profil?.id;
  const [currentPage, setCurrentPage] = useState(1);

  const dispatch = useAppDispatch();
  let reservationState: Reservation[] = useAppSelector((state) => state.featureReservation.reservations);
  let totalPages = useAppSelector((state) => state.featureReservation.totalPages);
  let totalCount = useAppSelector((state) => state.featureReservation.totalCount);
  let reservationStateOwner: Reservation[] = useAppSelector((state) => state.featureReservation.reservationOwner);

  const location = useLocation();

  useEffect(() => {
    if (profilId) {
      switch (location.pathname) {
        case "/client/mes-reservations":
          setIsLoading(true);
          dispatch(fetchReservationByOwner({ id: profilId, page: currentPage })).finally(() =>
            setIsLoading(false)
          );
          break;
        case "/client/mes-evenements":
          setIsLoading(true);
          dispatch(fetchReservationByOwnerAsClient({ id: profilId, page: currentPage })).finally(() =>
            setIsLoading(false)
          );
          break;
        case "/client/evenements":
          setIsLoading(true);
          dispatch(fetchReservationByOwnerAsClient({ id: profilId, page: currentPage })).finally(() =>
            setIsLoading(false)
          );
          break;
        default:
          break;
      }
    } else {
      console.log("❌ profilId is undefined/null");
    }
  }, [profilId, currentPage, location.pathname]);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  // Apply filtering for traditional views
  const filteredReservationState =
    selectedFilter === "all" || !filterStatus
      ? reservationState
      : reservationState.filter((reservation: any) => reservation.status === filterStatus);

  const filteredReservationStateOwner =
    selectedFilter === "all" || !filterStatus
      ? reservationStateOwner
      : reservationStateOwner?.filter((reservation: any) => reservation.status === filterStatus);

  // Use modern component for /client/evenements
  if (location.pathname === "/client/evenements") {
    return (
      <div className={`nc-SectionGridFilterCard ${className}`} data-nc-id="SectionGridFilterCard">
        <ModernClientEventsGrid
          loading={loading}
          reservations={reservationStateOwner || []}
          totalCount={totalCount}
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          selectedFilter={selectedFilter}
          filterStatus={filterStatus}
        />
      </div>
    );
  }

  // Keep traditional layout for other routes
  return (
    <div className={`nc-SectionGridFilterCard ${className}`} data-nc-id="SectionGridFilterCard">
      <div className="grid grid-cols-1 gap-6 rounded-3xl ">
        <Heading2
          heading={`${location.pathname === "/client/mes-reservations" ? "" : " Mes événements"}`}
          subHeading={
            location.pathname === "/client/mes-reservations" ? null : (
              <span className="block mt-3 text-neutral-500 dark:text-white">{totalCount} événements</span>
            )
          }
        />
        {loading ? (
          <div className="flex items-center justify-center mt-16 mb-2">
            <p>
              <Spinner color="blue" className="w-12 h-12" />
            </p>
          </div>
        ) : filteredReservationState?.length === 0 && filteredReservationStateOwner?.length === 0 ? (
          <div className="flex items-center justify-center mt-16">
            <p>Pas de reservations disponibles</p>
          </div>
        ) : location.pathname === "/client/mes-reservations" ? (
          filteredReservationState.map((item, index) => (
            <div key={index} className="mx-4">
              <ReservationsDetailedCard
                defaultOpen={!index}
                data={item}
                totalCount={filteredReservationState.length}
              />
            </div>
          ))
        ) : location.pathname === "/client/mes-evenements" ? (
          filteredReservationStateOwner?.map((item, index) => (
            <div key={index} className="mx-4">
              <ClientReservationDetailedCard
                defaultOpen={!index}
                data={item}
                totalCount={filteredReservationStateOwner.length}
              />
            </div>
          ))
        ) : null}
        <div className="flex items-center justify-center mt-16">
          {totalPages > 1 &&
            !loading &&
            (filteredReservationState.length > 8 || (filteredReservationStateOwner?.length || 0) > 8) && (
              <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            )}
        </div>
      </div>
    </div>
  );
};

export default MadeReservationGridDetailedCard;
